// Lightweight, dependency-free toast notifications (replaces toastr + jQuery).
// Public API is kept identical to the previous module: showToast / clearToasts.

const CONTAINER_ID = 'ds-toast-container';
const DURATION = 4000;
const LEAVE_MS = 200;
const ALLOWED_TYPES = ['success', 'error', 'warning', 'info'];

// Heroicons (mini) paths, inlined to avoid any runtime dependency.
/* eslint-disable max-len */
const ICONS = {
  success: 'M16.7 5.3a1 1 0 0 1 0 1.4l-7.5 7.5a1 1 0 0 1-1.4 0L3.3 9.7a1 1 0 0 1 1.4-1.4l3.1 3.1 6.8-6.8a1 1 0 0 1 1.4 0Z',
  error: 'M10 1.7a8.3 8.3 0 1 0 0 16.6 8.3 8.3 0 0 0 0-16.6ZM8.6 7.2 10 8.6l1.4-1.4 1.4 1.4L11.4 10l1.4 1.4-1.4 1.4L10 11.4l-1.4 1.4-1.4-1.4L8.6 10 7.2 8.6l1.4-1.4Z',
  warning: 'M9.1 2.5a1 1 0 0 1 1.8 0l7 12.1a1 1 0 0 1-.9 1.5H3a1 1 0 0 1-.9-1.5l7-12.1ZM10 7a.9.9 0 0 0-.9 1l.2 3a.7.7 0 0 0 1.4 0l.2-3A.9.9 0 0 0 10 7Zm0 6.2a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z',
  info: 'M10 1.7a8.3 8.3 0 1 0 0 16.6 8.3 8.3 0 0 0 0-16.6ZM9 6h2v2H9V6Zm0 3.5h2V14H9V9.5Z',
};
/* eslint-enable max-len */

function container() {
  let element = document.getElementById(CONTAINER_ID);
  if (!element) {
    element = document.createElement('div');
    element.id = CONTAINER_ID;
    element.className = 'ds-toast-container';
    document.body.appendChild(element);
  }
  return element;
}

function dismiss(toast) {
  if (toast.dataset.leaving) return;
  toast.dataset.leaving = 'true';
  toast.classList.add('is-leaving');
  setTimeout(() => toast.remove(), LEAVE_MS);
}

export function showToast(type, message) {
  if (!ALLOWED_TYPES.includes(type)) return;

  const toast = document.createElement('div');
  toast.className = `ds-toast ds-toast--${type}`;
  toast.setAttribute('role', type === 'error' ? 'alert' : 'status');

  const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  icon.setAttribute('viewBox', '0 0 20 20');
  icon.setAttribute('aria-hidden', 'true');
  icon.classList.add('ds-toast-icon');
  const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
  path.setAttribute('d', ICONS[type]);
  icon.appendChild(path);

  const text = document.createElement('span');
  text.className = 'ds-toast-msg';
  text.textContent = message; // textContent keeps the message HTML-safe.

  toast.append(icon, text);
  toast.addEventListener('click', () => dismiss(toast));
  container().appendChild(toast);

  setTimeout(() => dismiss(toast), DURATION);
}

export function clearToasts() {
  document.getElementById(CONTAINER_ID)?.remove();
}
